import { Stack } from '@mui/material'
import React from 'react'
import { useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { resetService } from '../../../slices/orderSlice'
import { MainContainer } from '../../containers'
import { MainButton } from '../../helpers'
import { ModalHeader } from '../../modals'
import { CilinderSize } from './CilinderSize'
import { InfoCilinder } from './InfoCilinder'
import { QTCilinders } from './QTCilinders'
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
export const CilinderView = () => {

  
  const dispatch = useDispatch();
  const navigate = useNavigate()
  const handleCancel = () => {
    dispatch(resetService())
    navigate('/dashboard/content', { replace: true })
  }
  const handleAdd = () => {
    navigate('/dashboard/preview')
  }

  // useEffect(() => {
  //   subTotal < 500 || subTotal > 10000 ? setAmountError(true) : setAmountError(false)
  // }, [subTotal])
  return (
    <MainContainer >
      <ModalHeader text="Solicitar Gas Cilindro"/>
      <CilinderSize />
      <QTCilinders />
      <InfoCilinder />
      <Stack mt={5} direction="row" spacing={3}>
        <MainButton text="CANCELAR" variant="outlined" size="50%" onClick={handleCancel}/>
        <MainButton text="AGREGAR" variant="contained" size="50%" onClick={handleAdd}/>
      </Stack>
    </MainContainer>
  )
}
